import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    BarChart,
    Bar,
    CartesianGrid
} from 'recharts';
import { Card, Statistic, Progress, Select } from 'antd';
const { Option } = Select;


const expenseSalesData = [
    { month: 'Jan', expense: 15000, sales: 10000 },
    { month: 'Feb', expense: 17000, sales: 6000 },
    { month: 'Mar', expense: 15000, sales: 9000 },
    { month: 'Apr', expense: 16000, sales: 6000 },
    { month: 'Jun', expense: 14000, sales: 12000 },
    { month: 'Jul', expense: 17000, sales: 18000 },
    { month: 'Sep', expense: 16000, sales: 15000 },
    { month: 'Dec', expense: 18000, sales: 20000 },
];

const pieData = [
    { name: 'Product A', value: 40 },
    { name: 'Product B', value: 25 },
    { name: 'Product C', value: 25 },
];

const topMonths = [
    { name: 'August', value: 90 },
    { name: 'July', value: 75 },
    { name: 'November', value: 50 },
];

const COLORS = ['#3b82f6', '#60a5fa', '#1e40af'];

export default function SalesDashboard() {
    return (
        <>
            <div className="flex justify-end space-x-2">
                <Select defaultValue="All" className="w-28">
                    <Option value="All">All</Option>
                    <Option value="BU1">BU1</Option>
                </Select>
                <Select defaultValue="Financial Year" className="w-40">
                    <Option value="Financial Year">Financial Year</Option>
                </Select>
                <Select defaultValue="F 2024 - 2025" className="w-40">
                    <Option value="F 2024 - 2025">F 2024 - 2025</Option>
                </Select>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

                <Card className="col-span-1">
                    <Statistic title="Total Expenses" value={25000} valueStyle={{ color: 'red' }} prefix="₹" suffix={<div className="text-sm">Last year ₹23,500</div>} />
                </Card>
                <Card className="col-span-1">
                    <Statistic title="Total Sales" value={25000} valueStyle={{ color: 'green' }} prefix="₹" suffix={<div className="text-sm">+5% from last year</div>} />
                </Card>
                <Card className="col-span-1">
                    <div className="w-full h-48">
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={pieData}
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={50}
                                    dataKey="value"
                                    label
                                >
                                    {pieData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="text-center mt-2 font-medium">Sales by Category</div>
                </Card>

                <Card className="col-span-2">
                    <div className="w-full h-64">
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={expenseSalesData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Line type="monotone" dataKey="expense" stroke="#f5222d" name="Expense" strokeWidth={2} />
                                <Line type="monotone" dataKey="sales" stroke="#8c8cff" name="Sales" strokeWidth={2} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="text-center mt-2 font-medium">Expenses vs Sales Trend</div>
                </Card>

                <Card>
                    <Statistic title="Conversion Rate" value={15} suffix="%" />
                </Card>

                <Card>
                    <Statistic title="Deals Closed" value={50} />
                </Card>

                <Card>
                    <Statistic title="Sales Target" value={60} suffix="%" />
                </Card>

                <Card>
                    <Statistic title="Avg Deal Size" value={50000} prefix="₹" />
                    <Progress percent={60} status="active" className="mt-2" />
                </Card>

                <Card className="col-span-1">
                    <div className="w-full h-48">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={topMonths} layout="vertical">
                                <XAxis type="number" />
                                <YAxis dataKey="name" type="category" />
                                <Bar dataKey="value" fill="#3b82f6" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="text-center mt-2 font-medium">Top Performing Months</div>
                </Card>

                <Card className="col-span-1">
                    <div className="w-full h-48">
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={expenseSalesData}>
                                <XAxis dataKey="month" />
                                <YAxis />
                                <Tooltip />
                                <Line type="monotone" dataKey="sales" stroke="#3b82f6" name="Forecast" />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="text-center mt-2 font-medium">Sales Forecast</div>
                </Card>
            </div>
        </>
    );
}